import React from "react";

// utils
import { twMerge } from "tailwind-merge";

// https://www.material-tailwind.com/docs/react/list
// list components
import { ListItem, ListItemProps } from "./ListItem";
import { ListItemPrefix, ListItemPrefixProps } from "./ListItemPrefix";
import { ListItemSuffix, ListItemSuffixProps } from "./ListItemSuffix";
// types
import { objectsToString } from "@/components/utils";
import {
    children,
    className,
    propTypesChildren,
    propTypesClassName,
} from "@/components/utils/types";
import clsx from "clsx";
import { list } from "./listStyle";

export interface ListProps extends React.ComponentProps<"div"> {
  className?: className;
  children: children;
}

export const List = React.forwardRef<HTMLDivElement, ListProps>(
  ({ className, children, ...rest }, ref) => {
    // 1. init
    const { defaultProps, styles } = list;

    // 2. set default props
    className = twMerge(defaultProps?.className || "", className);

    // 3. set styles
    const listClasses = twMerge(
      clsx(objectsToString(styles?.base?.list)),
      className
    );

    return (
      <nav {...rest} ref={ref} className={listClasses}>
        {children}
      </nav>
    );
  }
);

List.propTypes = {
  className: propTypesClassName,
  children: propTypesChildren,
};

List.displayName = "List";

export { ListItem, ListItemPrefix, ListItemSuffix };
export type { ListItemPrefixProps, ListItemProps, ListItemSuffixProps };
